
define('ldsh!modules/lp_integration/templates/mdirector_fields_steps', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group">\n  <div>\n    <span class="ed-help-block js-error-message" id="fields-message"></span>\n  </div>\n</div>\n<div id="fields-step" class="ed-fields-step">\n</div>\n<div class="ed-section-group">\n  <h1 data-i18n="integration.automatic_fields" class="ed-section-title">Campos automáticos</h1>\n  ';
 hasFormFields && _.each(defaultFields, function(field){ ;
__p += '\n  <div class="ed-form-group ed-form-group-inline js-fieldmapping ed-system-item" data-field="' +
((__t = (field)) == null ? '' : __t) +
'">\n    <label data-i18n="integration.' +
((__t = ( field )) == null ? '' : __t) +
'">' +
((__t = ( field )) == null ? '' : __t) +
'</label>\n    <div>\n      <select class="ed-form-control ed-form-item-full js-mdirector-fields" data-field="' +
((__t = (field)) == null ? '' : __t) +
'">\n      </select>\n    </div>\n  </div>\n  ';
 }) ;
__p += '\n</div>\n';

}
return __p
};});

